import type { FC } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { HeaderModal } from '../../../../store/slices/header/types';

import { HelpControlPlain } from './HelpControlPlain';

export const HelpControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();

  return (
    <HelpControlPlain
      condition={openedModal === HeaderModal.Help}
      onClick={(): void => {
        if (openedModal === HeaderModal.Help) {
          dispatch(headerActions.setOpenedModal(null));
        } else {
          Logger.logEvent('click', 'openHelp', Date.now(), 1, '', false);
          dispatch(headerActions.setOpenedModal(HeaderModal.Help));
        }
      }}
    />
  );
};
